module.exports = __webpack_public_path__ + "img/Iinitial-popup-4@2x.03e308ee.png";